import { createAsyncThunk } from "@reduxjs/toolkit";
import { environment } from "../../environments";
import {
  CreateBookkeepingDocumentRequest,
  CreateBookkeepingDocumentResponse,
  GetBookkeepingDocumentRequest,
  GetBookkeepingDocumentResponse,
} from "../../models/BookkeepingDocument.model";

const API_BASE_URL = environment.apiUrl;

// יצירת מסמך הנהלת חשבונות
export const createBookkeepingDocument = createAsyncThunk<
  CreateBookkeepingDocumentResponse,
  CreateBookkeepingDocumentRequest,
  { rejectValue: string | CreateBookkeepingDocumentResponse }
>(
  "bookkeepingDocument/createBookkeepingDocument",
  async (requestData, { rejectWithValue }) => {
    try {
      // Assume documentItems are always DocumentItemDTO[] and documentPayment is valid
      const payload: CreateBookkeepingDocumentRequest = {
        token: requestData.token,
        companyKey: requestData.companyKey,
        bookkeepingDocument: requestData.bookkeepingDocument,
        documentItems: requestData.documentItems ?? [],
        documentPayment: requestData.documentPayment ?? [],
        withApprovalNumber: requestData.withApprovalNumber ?? true,
      };

      const response = await fetch(
        `${API_BASE_URL}BookkeepingDocument/CreateBookkeepingDocument`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        },
      );

      if (!response.ok) {
        throw new Error(`HTTP ${response.status}`);
      }

      const data: CreateBookkeepingDocumentResponse = await response.json();

      if (
        !data.success &&
        data.requiresAuthorization &&
        data.authorizationUrl
      ) {
        localStorage.setItem("pendingBkDoc", JSON.stringify(requestData));
        localStorage.setItem(
          "invoiceIsraelAuthorizationUrl",
          data.authorizationUrl,
        );
        localStorage.setItem(
          "invoiceIsraelAuthorizationMessage",
          data.message || "נדרשת הזדהות לחשבונית ישראל לפני הנפקת מסמך",
        );
        localStorage.setItem(
          "invoiceIsraelCanContinueWithoutApproval",
          data.canContinueWithoutApprovalNumber ? "true" : "false",
        );

        return rejectWithValue("AUTHORIZATION_REQUIRED_REDIRECT");
      }

      if (!data.success) {
        if (data.canContinueWithoutApprovalNumber) {
          return rejectWithValue(data);
        }

        return rejectWithValue(
          data.message || "נכשל ביצירת מסמך הנהלת חשבונות",
        );
      }

      return data;
    } catch (error) {
      return rejectWithValue(
        error instanceof Error
          ? error.message
          : "שגיאה לא ידועה ביצירת מסמך הנהלת חשבונות",
      );
    }
  },
);
export const getBookkeepingDocument = createAsyncThunk<
  GetBookkeepingDocumentResponse,
  GetBookkeepingDocumentRequest,
  { rejectValue: string }
>(
  "bookkeepingDocument/getBookkeepingDocument",
  async (requestData, { rejectWithValue }) => {
    try {
      // Assume documentItems are always DocumentItemDTO[] and documentPayment is valid

      const response = await fetch(
        `${API_BASE_URL}BookkeepingDocument/GetBookkeepingDocument`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(requestData),
        },
      );

      if (!response.ok) {
        throw new Error(`HTTP ${response.status}`);
      }

      const data: GetBookkeepingDocumentResponse = await response.json();

      if (!data.success) {
        return rejectWithValue(data.message || "נכשל בקבלת מסמך הנהלת חשבונות");
      }

      return data;
    } catch (error) {
      return rejectWithValue(
        error instanceof Error
          ? error.message
          : "שגיאה לא ידועה בקבלת מסמך הנהלת חשבונות",
      );
    }
  },
);
